export default "__VITE_ASSET__BZr$IypU__"